export const CASH_BANK_REGISTER_REPORT_REQUEST = 'CASH_BANK_REGISTER_REPORT_REQUEST';
export const CASH_BANK_REGISTER_REPORT_SUCCESS = 'CASH_BANK_REGISTER_REPORT_SUCCESS';
export const CASH_BANK_REGISTER_REPORT_FAILURE = 'CASH_BANK_REGISTER_REPORT_FAILURE';